import { createContext } from 'react';
import { ICategoryV2, TCategoryType } from 'types';

export type TSortBy = '' | 'CategoriesA-Z' | 'CategoriesZ-A' | 'CategoryTypeA-Z' | 'CategoryTypeZ-A';
export type TCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'success'
	| 'error'
	| 'assignRestaurants'
	| 'errorUpdatingCategory';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDsSelectedCategoryTypes: TCategoryType[];
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface ICategoryState {
	needRefetchData: boolean;
	categories: ICategoryV2;
	searchString: string;
	rememberMyChoice: boolean;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDsSelectedCategoryTypes: TCategoryType[];
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForAssignRestaurants: string;
	isInitializedSelectCustomerModal: boolean;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const categoryInitialState: ICategoryState = {
	needRefetchData: false,
	categories: { totalCount: 0, items: [] },
	searchString: '',
	rememberMyChoice: true,
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDsSelectedCategoryTypes: [],
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForAssignRestaurants: '',
	isInitializedSelectCustomerModal: false,
	typeOfModalWindow: null,
};

export interface ICategoryContext extends ICategoryState {
	refetchData(value: boolean): void;
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	toggleRememberMyChoice(): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDsSelectedCategoryTypes(value: TCategoryType[]): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForAssignRestaurants(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const CategoryContext = createContext<ICategoryContext>({
	refetchData: () => undefined,
	deleteSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	toggleRememberMyChoice: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDsSelectedCategoryTypes: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForAssignRestaurants: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...categoryInitialState,
});
